/**
 * A small labelled statistic card (used across the dashboard: success %, median terminal wealth,
 * worst drawdown, etc). Label in muted UI caps, value in the display/mono family. Optional tone
 * (`pos`/`neg`/`warn`) colors the value; optional sub note below.
 */
export interface StatCardProps {
  label: string;
  /** The pre-formatted value string (caller formats via design/format). */
  value: React.ReactNode;
  tone?: 'default' | 'pos' | 'neg' | 'warn';
  note?: string;
  /** Use the display serif for the value (big headline numbers) vs the mono (data). */
  emphasis?: 'display' | 'mono';
}

export function StatCard({
  label,
  value,
  tone = 'default',
  note,
  emphasis = 'mono',
}: StatCardProps): React.ReactElement {
  const toneClass = tone === 'pos' ? 'num--pos' : tone === 'neg' ? 'num--neg' : '';
  const fontFamily = emphasis === 'display' ? 'var(--font-display)' : 'var(--font-mono)';
  return (
    <div className="card">
      <div className="card__title">{label}</div>
      <div
        className={`num ${toneClass}`}
        style={{ fontFamily, fontSize: 'var(--fs-display)', lineHeight: 1.05 }}
      >
        {value}
      </div>
      {note !== undefined && (
        <div
          style={{
            color: 'var(--ink-muted)',
            fontSize: 'var(--fs-small)',
            marginTop: 'var(--sp-2)',
          }}
        >
          {note}
        </div>
      )}
    </div>
  );
}
